export function getDailyPricesSum(dailyPrices, field = 'price') {
  if (!dailyPrices) {
    return 0
  }
  return dailyPrices.reduce((sum, item) => (sum += item[field]), 0)
}
